import { create } from "zustand";

type SheetState = {
  isOpen: boolean;
  title?: React.ReactNode;
  header?: React.ReactNode;
  content: React.ReactNode | null;
  footer: React.ReactNode | null;
  onCloseCallback: () => void;
  width: string | number;
  enableFullscreen?: boolean;
  enableCopyUrl?: boolean;
  isFullscreen?: boolean;
  onToggleFullscreen?: () => void;
  openSheet: ({
    title,
    header,
    content,
    footer,
    onCloseCallback,
    width,
    isFullscreen,
    onToggleFullscreen,
  }: {
    title?: React.ReactNode;
    header?: React.ReactNode;
    content: React.ReactNode;
    footer?: React.ReactNode;
    onCloseCallback?: () => void;
    width?: string | number;
    enableFullscreen?: boolean;
    enableCopyUrl?: boolean;
    isFullscreen?: boolean;
    onToggleFullscreen?: () => void;
  }) => void;
  closeSheet: () => void;
  updateWidth: (width: string) => void;
  toggleFullscreen: (isFullscreen: boolean) => void;
};

export const useSheetStore = create<SheetState>((set, get) => ({
  isOpen: false,
  title: null,
  header: null,
  content: null,
  footer: null,
  onCloseCallback: () => {},
  width: "25vw",
  enableFullscreen: false,
  enableCopyUrl: false,
  isFullscreen: false,
  onToggleFullscreen: () => {},
  openSheet: ({
    title,
    header = null,
    content,
    footer = null,
    width = "25vw",
    enableFullscreen = false,
    enableCopyUrl = false,
    isFullscreen = false,
    onToggleFullscreen = () => {},
    onCloseCallback = () => {},
  }) =>
    set({
      isOpen: true,
      title,
      header,
      content,
      footer,
      enableFullscreen,
      enableCopyUrl,
      width,
      isFullscreen,
      onToggleFullscreen,
      onCloseCallback,
    }),
  updateWidth: (width: string) => set({ width }),
  toggleFullscreen: (isFullscreen: boolean) => set({ isFullscreen }),
  closeSheet: () => {
    const { onCloseCallback } = get();
    if (onCloseCallback) onCloseCallback();
    set({
      isOpen: false,
      title: null,
      header: null,
      content: null,
      footer: null,
      enableFullscreen: false,
      enableCopyUrl: false,
      onCloseCallback: () => {},
      width: "25vw",
    });
  },
}));
